import { CropOverlay } from './CropOverlay';
import { EditorStage } from './EditorStage';
import { RegionLayer } from './RegionLayer';
import { WatermarkOverlay } from './WatermarkOverlay';

export function MatteStage() {
  return (
    <EditorStage
      overlays={
        <>
          <CropOverlay />
          <WatermarkOverlay />
          <RegionLayer />
        </>
      }
    />
  );
}
